module.exports = __webpack_public_path__ + "static/media/hackerrank.ade72ebd.png";